import React, { Component } from "react";
import { Link } from 'react-router-dom';
const Portfolio_image = <img src="/assets/images/portfolio/portfolio-static-01.jpg" alt="React Creative Agency" />;
const Portfolio_image2 = <img src="/assets/images/portfolio/portfolio-static-02.jpg" alt="React Creative Agency" />;
const Portfolio_image3 = <img src="/assets/images/portfolio/brochures/Lindstorm/Lindstorm-brochure-1.jpg" alt="React Creative Agency" />;
const Portfolio_image4 = <img src="/assets/images/portfolio/portfolio-static-04.jpg" alt="React Creative Agency" />;
const Portfolio_image5 = <img src="/assets/images/portfolio/portfolio-static-05.jpg" alt="React Creative Agency" />;
const Portfolio_image6 = <img src="/assets/images/portfolio/portfolio-static-06.jpg" alt="React Creative Agency" />;
const Portfolio_image7 = <img src="/assets/images/portfolio/portfolio-static-07.jpg" alt="React Creative Agency" />;
const Portfolio_image8 = <img src="/assets/images/portfolio/portfolio-static-08.jpg" alt="React Creative Agency" />;
const Portfolio_image9 = <img src="/assets/images/portfolio/portfolio-static-09.jpg" alt="React Creative Agency" />;
const Portfolio_image10 = <img src="/assets/images/portfolio/portfolio-static-01.jpg" alt="React Creative Agency" />;
const Portfolio_image11 = <img src="/assets/images/portfolio/portfolio-static-08.jpg" alt="React Creative Agency" />;
const Portfolio_image12 = <img src="/assets/images/portfolio/portfolio-static-05.jpg" alt="React Creative Agency" />;



const PortfolioList = [
    {
        image: Portfolio_image,
        category: 'Corporate Identity',
        title: 'Logo Design',
        description: 'Beautiful modern logos to Create a brand image for your business',
        locations: '/corporate-logo'

    },
    {
        image: Portfolio_image2,
        category: 'Package Design',
        title: 'Product Mockups',
        description: 'create a product packaging design which will create a brand image',
        locations: '/package-des'

    },
    {
        image: Portfolio_image3,
        category: 'Branding',
        title: 'Brochures Design',
        description: 'The Perfect Brochure Design for your business.',
        locations: '/brochure-design'

    },
    {
        image: Portfolio_image4,
        category: 'Our Clients Videos',
        title: 'Branding Videos',
        description: 'Check our works by our clients videos.',
        locations: '/videos'

    },
    {
        image: Portfolio_image5,
        category: 'Web Design',
        title: 'Responsive Web Design',
        description: 'Design and development of static, dynamic and eComercial website',
        locations: '/web-design'

    },
    {
        image: Portfolio_image6,
        category: 'Social Profiles',
        title: 'Social Media Posts',
        description: 'Promote products and services in social media marketing.',
        locations: '/Socialmediaposter'

    },
    {
        image: Portfolio_image7,
        category: 'Others',
        title: 'Other Projects',
        description: 'Creative Advertising providing services include hoardings,flex printing',
        locations: '/others'
    },
    {
        image: Portfolio_image8,
        category: 'Photography',
        title: 'Professional Photography',
        description: 'Elevate your business with our professional photography services.'
    },
    {
        image: Portfolio_image9,
        category: 'Application',
        title: 'Photoshop Design',
        description: 'Lorem ipsum dolor sit amet, consec tetur adipiscing elit.'
    },
    {
        image: Portfolio_image10,
        category: 'Application',
        title: 'Photoshop Design',
        description: 'Lorem ipsum dolor sit amet, consec tetur adipiscing elit.'
    },
    {
        image: Portfolio_image11,
        category: 'Application',
        title: 'Photoshop Design',
        description: 'Lorem ipsum dolor sit amet, consec tetur adipiscing elit.'
    },
    {
        image: Portfolio_image12,
        category: 'Application',
        title: 'Photoshop Design',
        description: 'Lorem ipsum dolor sit amet, consec tetur adipiscing elit.'
    },
]


class PortfolioMasonry extends Component{
    render(){
        const {column } = this.props;
        const list = PortfolioList.slice(0 , this.props.item);
        return(
            <React.Fragment>
                {list.map((value , index) => (
                    <div className={`${column}`} key={index}>
                        <div className="im_portfolio">
                            <div className="thumbnail_inner">
                                <div className="thumbnail">
                                    <Link to={value.locations}>
                                        {value.image}
                                    </Link>    
                                </div>
                            </div>
                            <div className="content">
                                <div className="inner">
                                    <div className="portfolio_heading">
                                        <div className="category_list">
                                            <Link to={value.locations}>{value.category}</Link>
                                        </div>
                                        <h4 className="title"><Link to={value.locations}>{value.title}</Link></h4>
                                    </div>
                                    <div className="portfolio_hover">
                                        <p>{value.description}</p>
                                    </div>
                                </div>
                            </div>
                            <Link className="transparent_link" to={value.locations}></Link>
                        </div>
                    </div>
                ))}
               
            </React.Fragment>
        )
    }
}
export default PortfolioMasonry;